import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { goToStore } from "domain/Analytics/actions";

const MobileAppsLinks = () => {
    const dispatch = useDispatch();

    return (
        <div className="about__apps">
            <a
                href="https://apps.apple.com/ru/app/naigru/id1570853592"
                target="_blank"
                rel="noopener noreferrer"
                title="Мобильное приложение для iOS"
                onClick={() => dispatch(goToStore())}
            >
                <img
                    src="/images/appstore.png"
                    alt="Мобильное приложение для iOS"
                />
            </a>

            <a
                href="https://play.google.com/store/apps/details?id=ru.itgro.naigru"
                target="_blank"
                rel="noopener noreferrer"
                title="мобильное приложение для Android"
                onClick={() => dispatch(goToStore())}
            >
                <img
                    src="/images/googleplay.png"
                    alt="мобильное приложение для Android"
                />
            </a>
        </div>
    );
};

MobileAppsLinks.propTypes = {
    goToStore: PropTypes.func,
};

export default MobileAppsLinks;
